import axios from "axios";
import { common } from "../../utils";
import { API_URL } from "../../utils/api-utils";

export const GetListConfigMasterTemplate = async (param) => {
  let url = `${API_URL.Loader}/api/ConfigMasterTemplate/GetListConfigMasterTemplate`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};

export const GetConfigMasterTemplate = async (param) => {
  let url = `${API_URL.Loader}/api/ConfigMasterTemplate/GetConfigMasterTemplate`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};

export const GetListViewUploadTemplateHistory = async (param) => {
  let url = `${API_URL.Loader}/api/ConfigMasterTemplate/GetListViewUploadTemplateHistory`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};

export const DownloadTemplate = async (param) => {
  let url = `${API_URL.Loader}/api/ConfigMasterTemplate/DownloadTemplate`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};

export const UploadTemplate = async (param) => {
  let url = `${API_URL.Loader}/api/ConfigMasterTemplate/UploadTemplate`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};

export const DeleteConfigMasterTemplate = async (param) => {
  let url = `${API_URL.Loader}/api/ConfigMasterTemplate/DeleteConfigMasterTemplate`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};
